import { c as _c } from "react/compiler-runtime";
import { CarouselV2 } from "@website/ui/carousel";
import { LazyImage } from "@website/ui/lazy-image";
import background from "./assets/commentsback.png";
import backgroundMobile from "./assets/commentsbackmobile.png";
import coat from "./assets/coat.png";
import type { HostExperienceItem, VillaHostExperienceCarouselProperties } from "./VillaHostExperienceCarousel.types";
const AUTO_SLIDE_INTERVAL_IN_MS = 10_000;
const TestimonialSlide = t0 => {
  const $ = _c(24);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.title) {
    t1 = <div className="pb-10 text-xl font-bold max-lg:pb-7 lg:text-2xl">{item.title}</div>;
    $[0] = item.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LazyImage alt="" src={coat.src} className="pb-2 max-lg:max-w-8" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.name) {
    t3 = <p className="text-subtitle-1 pb-2">{item.name}</p>;
    $[3] = item.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== item.role) {
    t4 = <p className="text-body-2 text-on-surface-medium-emphasis lg:text-body-1 w-max max-lg:pl-2">{item.role}</p>;
    $[5] = item.role;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="items-center justify-center gap-4 max-lg:flex">{t2}<div>{t3}{t4}</div></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== item.quote) {
    t6 = <div className="flex h-full max-w-[526px] items-center rounded-2xl bg-white p-4 text-xs leading-7">{item.quote}</div>;
    $[10] = item.quote;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex items-center gap-1 max-lg:flex-col max-lg:items-start lg:h-32 lg:gap-4">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t1 || $[16] !== t7) {
    t8 = <div className="flex flex-col">{t1}{t7}</div>;
    $[15] = t1;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== item.name || $[19] !== item.pic) {
    t9 = <div className="rounded-3xl bg-white/70"><LazyImage alt={item.name} src={item.pic} /></div>;
    $[18] = item.name;
    $[19] = item.pic;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <div className="flex size-full items-center justify-between max-lg:flex-col max-lg:gap-7 xl:mx-auto xl:max-w-[1200px] xl:px-0">{t8}{t9}</div>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
const Component = t0 => {
  const $ = _c(7);
  const {
    testimonials
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-y-0 right-0 hidden w-1/2 bg-right bg-no-repeat lg:block" style={{
      backgroundImage: `url(${background.src})`,
      backgroundSize: "cover"
    }} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-y-0 block w-full bg-right bg-no-repeat lg:hidden" style={{
      backgroundImage: `url(${backgroundMobile.src})`,
      backgroundSize: "cover"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== testimonials) {
    t3 = testimonials.map(_temp);
    $[2] = testimonials;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: true,
      slides: {
        perView: 1,
        spacing: 0
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="bg-dim-background relative overflow-hidden">{t1}{t2}<div className="relative z-10 p-6 lg:py-10"><CarouselV2 autoSlideInterval={AUTO_SLIDE_INTERVAL_IN_MS} dotsClassName="!-bottom-6" hasDots={true} hasNavigation={false} itemClass="w-full" keyCarousel="villa-host-experience" list={t3} mode="free-snap" options={t4} /></div></div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export const VillaHostExperienceCarousel = Component;
function _temp(testimonial) {
  return <TestimonialSlide item={testimonial} key={testimonial.name} />;
}